document.addEventListener('DOMContentLoaded', function () {
	const wwdContainer = document.querySelector('.wwd');
	if (!wwdContainer) return;

	initTocLinks();
	initConnectionLinks();
});

function initTocLinks() {
	const tocLinks = document.querySelectorAll('.wwd__toc a');
	tocLinks.forEach(link => {
		link.addEventListener('click', handleTocClick);
	});
}

function handleTocClick(e) {
	const tocLinks = document.querySelectorAll('.wwd__toc a');
	tocLinks.forEach(l => l.classList.remove('active'));
	document.querySelectorAll('.wwd__city.active').forEach(city => city.classList.remove('active'));

	const targetId = this.getAttribute('href').replace('#', '');
	const target = document.getElementById(targetId);
	if (target) {
		e.preventDefault();
		this.classList.add('active');
		target.classList.add('active');
		target.scrollIntoView({ behavior: 'smooth', block: 'start' });
	}
}

function initConnectionLinks() {
	const connectionLinks = document.querySelectorAll('.wwd__connection a');
	connectionLinks.forEach(link => {
		link.addEventListener('click', handleConnectionClick);
	});
}

function handleConnectionClick(e) {
	e.preventDefault();
	window.open(this.href, '_blank', 'noopener');
}
